import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { formatPrice, formatTimeAgo } from "@/lib/utils-app";
import { Skeleton } from "@/components/ui/skeleton";
import { Briefcase, ChevronRight } from "lucide-react";

export function Jobs() {
  const { data: jobs, isLoading } = useQuery({
    queryKey: ["jobs"],
    queryFn: async () => (await api.get("/jobs/mine")).data,
  });

  return (
    <div className="px-4 sm:px-6 pt-6 sm:pt-10 space-y-4" data-testid="jobs-page">
      <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Lavori</h1>

      {isLoading ? (
        <div className="space-y-3">{[1, 2].map((i) => <Skeleton key={i} className="h-24 rounded-3xl" />)}</div>
      ) : jobs?.length ? (
        <div className="grid gap-3 sm:grid-cols-2" data-testid="jobs-list">
          {jobs.map((j) => (
            <Link key={j.id} to={`/lavori/${j.id}`} data-testid={`job-${j.id}`}
              className="flex items-center gap-3 bg-white rounded-3xl border border-slate-100 shadow-sm p-4 hover:border-whoo/40 transition-colors active:scale-[0.99]">
              <div className="flex-1 min-w-0 space-y-1">
                <div className="flex items-center justify-between gap-2">
                  <p className="font-semibold text-slate-900 text-sm truncate">{j.title || j.request_title || `Lavoro #${String(j.id).slice(0, 8)}`}</p>
                  <StatusBadge status={j.status} testid={`job-status-${j.id}`} />
                </div>
                <p className="text-xs text-slate-500">
                  {j.price != null && <span className="font-semibold text-slate-700">{formatPrice(j.price)} · </span>}
                  {formatTimeAgo(j.created_at)}
                </p>
              </div>
              <ChevronRight className="w-4 h-4 text-slate-300 shrink-0" />
            </Link>
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-3xl border border-slate-100 shadow-sm p-8 text-center space-y-2" data-testid="empty-jobs">
          <Briefcase className="w-8 h-8 text-slate-300 mx-auto" />
          <p className="text-sm text-slate-500">Nessun lavoro attivo. I lavori nascono quando un'offerta viene accettata.</p>
        </div>
      )}
    </div>
  );
}
